import { useEffect, useState } from 'react';
import useIndustriesByCategoryQuery from '~hooks/query/home/useIndustriesByCategory';
import useGetIndustryByCode from '~hooks/useGetIndustryByCode';
import { IndustryItem } from '~types/company';
import { MENU_TYPE } from '../constants';
import { getIndustryCategory } from './helper';

export function useGetCatetoryIndustriesMenu(selectedMenu?: MENU_TYPE) {
  const [industriesMenu, setIndustriesMenu] = useState<IndustryItem[]>([]);
  const { getIndustryByCode } = useGetIndustryByCode();
  const { data: industriesByCategory } = useIndustriesByCategoryQuery(
    getIndustryCategory(selectedMenu),
  );

  useEffect(() => {
    if (!getIndustryCategory(selectedMenu)) {
      setIndustriesMenu([]);
    }
  }, [selectedMenu]);

  useEffect(() => {
    if (industriesByCategory) {
      const newArray = [
        {
          name: '전체',
          code: 'TOTAL',
        },
        ...industriesByCategory?.map((industryCode) => {
          return getIndustryByCode(industryCode) as IndustryItem;
        }),
      ];

      setIndustriesMenu(newArray);
    }
  }, [industriesByCategory]);

  return industriesMenu;
}
